import React from 'react';

// Browser notification permission status box (Push integration)
export function PushPermissionBox({ permissionStatus, onRequestPermission }) {
    return (
        <div className={`rounded-xl p-6 border ${permissionStatus === 'granted' ? 'bg-green-50 border-green-200' : permissionStatus === 'denied' ? 'bg-red-50 border-red-200' : 'bg-orange-50 border-orange-200'}`}>
            {permissionStatus === 'granted' ? (
                <p className="text-green-800">Notifications are enabled.</p>
            ) : (
                <div className="flex items-center justify-between">
                    <p className={permissionStatus === 'denied' ? 'text-red-800' : 'text-orange-800'}>
                        {permissionStatus === 'denied' ? 'Notifications blocked.' : 'Enable notifications.'}
                    </p>
                    {permissionStatus !== 'denied' && (
                        <button type="button" onClick={onRequestPermission} className="px-4 py-2 bg-white border border-orange-300 rounded-lg text-sm">Enable</button>
                    )}
                </div>
            )}
        </div>
    );
}
